import { Pipe, PipeTransform } from '@angular/core';
import { IMenuItem } from '../models/nav-item.model';

@Pipe({
  name: 'showAfter',
  standalone: true,
})
export class ShowAfterPipe implements PipeTransform {
  transform(menuItems: IMenuItem[] | undefined | null, thresholdAmount: number): boolean {
    return this.getTotalMenuItemsLength(menuItems || []) >= thresholdAmount;
  }

  private getTotalMenuItemsLength(menuItems: IMenuItem[]): number {
    return menuItems.reduce<number>((acc, menuItem): number => {
      if ('items' in menuItem) {
        return acc + this.getTotalMenuItemsLength(menuItem.items as IMenuItem[]);
      } else {
        return acc + 1;
      }
    }, 0);
  }
}
